import axiosIns from '@/api/axios'

export const GET_ROLE_MENU = (args) => {
    return axiosIns.get('/menu/role', args)
}

export const GET_ROLE = (args) => {
    return axiosIns.get('/role', args)
}

export const GET_ROLE_BY_ID = (args) => {
    return axiosIns.get(`/role/${args}`)
}

export const EDIT_ROLE = (args) => {
    return axiosIns.put(`/rolex/${args.id}`, args.requestData)
}

